import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject, Subscription, of } from 'rxjs';
import { catchError, debounceTime, switchMap, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { userHasMenu } from '../auth/menu-access';
import { ChatRefCard, ChatRefType, ChatService } from '../stokker/api/chat.service';

interface Tab {
  type: ChatRefType;
  label: string;
  placeholder: string;
  menu: string;
}

const TABS: Tab[] = [
  { type: 'order', label: 'Rendelés', placeholder: 'Rendelésszám, vevő neve, e-mail…', menu: 'Rendelések' },
  { type: 'ticket', label: 'Task', placeholder: 'T-12 vagy a task címe…', menu: 'Support' },
  { type: 'mail', label: 'Levelezés', placeholder: 'L-5, tárgy, feladó…', menu: 'Levelezés' },
  { type: 'po', label: 'Beszerzés', placeholder: 'B-12, beszállító, termék…', menu: 'Beszerzés' },
];

/** Rendelés / task / levelezés kiválasztása a chat-üzenethez (a jogosultság szerinti fülekkel). */
@Component({
  selector: 'app-chat-ref-picker',
  templateUrl: './chat-ref-picker.component.html',
  styleUrls: ['./chat-ref-picker.component.scss'],
})
export class ChatRefPickerComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() pick = new EventEmitter<ChatRefCard>();
  @Output() close = new EventEmitter<void>();
  @ViewChild('search') search?: ElementRef<HTMLInputElement>;

  tabs: Tab[] = [];
  tab: Tab | null = null;
  q = '';
  results: ChatRefCard[] = [];
  loading = false;
  error = '';
  private readonly query$ = new Subject<void>();
  private sub?: Subscription;

  constructor(private chat: ChatService, private auth: AuthService) {}

  ngOnInit(): void {
    this.tabs = TABS.filter((t) => userHasMenu(this.auth.user, t.menu));
    this.tab = this.tabs[0] || null;
    this.sub = this.query$.pipe(
      debounceTime(220),
      tap(() => {
        this.loading = true;
        this.error = '';
      }),
      switchMap(() => (this.tab ? this.chat.searchRefs(this.tab.type, this.q) : of([])).pipe(
        catchError((e) => {
          this.error = e?.error?.message || 'A keresés nem sikerült.';
          return of([] as ChatRefCard[]);
        }),
      )),
    ).subscribe((list) => {
      this.results = list;
      this.loading = false;
    });
    this.query$.next();
  }

  ngAfterViewInit(): void {
    if (!window.matchMedia('(hover: none)').matches) {
      setTimeout(() => this.search?.nativeElement.focus());
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  setTab(tab: Tab): void {
    this.tab = tab;
    this.results = [];
    this.query$.next();
    this.search?.nativeElement.focus();
  }

  onQuery(): void {
    this.query$.next();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.close.emit();
  }
}
